import React, { Component } from "react";
import CloseIcon from "../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Table, Tag, Button, Popconfirm, Alert, Modal } from "antd";
import {
  permissionTranslation,
  sendNotification,
  getWithDrawer
} from "../../utils";
import {
  addObjectoToGroup,
  removeObjectFromGroup,
  getGroupById,
  deleteGroupById,
  getGroupByClient,
  approvedRejectedUserRequest
} from "../../actions/GroupAction";
import PermissionRequest from "../my-permissions/permissionRequest";
import { getRootFoldersByClient } from "../../actions/ClientAction";
import Detail from "./Detail";
import { Spin } from "antd";
import { givingPermissions } from "../../actions/PermissionAction";
import "./list.css";

const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0"
};

export class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [],
      showDetail: false,
      showPermissionRequest: false,
      itemButton: null,
      groupId: null,
      mergedData: []
    };
  }

  componentDidMount() {
    this.setData();
  }

  setData() {
    // const { isSelectable, isRemovable, dataSelected, authUser, intl, data, otherGroup, item, defaultPermissions } = this.props
    const {
      isSelectable,
      isRemovable,
      authUser,
      intl,
      data,
      otherGroup,
      defaultPermissions,
      newColor
    } = this.props;
    const disableControls =
      authUser.role === "admin" || authUser.clientRole === "admin"
        ? false
        : true;
    const param = this.props.location.pathname.split("/").pop();
    const mergedData = data && data.map(group => {
      return {
        ...group,
        permissions: this.mergePermissions(
          group.permissions,
          defaultPermissions
        )
      };
    });

    if (param !== "groups") {
      const group = data && data.find(r => r._id === param);
      if (group) this.handleShowDetail(group._id);
    }

    const defaultColumns = [
      {
        key: "1",
        width: 200,
        title: intl.formatMessage({ id: "group_name" }),
        dataIndex: "name"
      },
      {
        key: "2",
        title: intl.formatMessage({ id: "permissions" }),
        dataIndex: "permission",
        render: (text, data) => (
          <span className="groups-tour-permission">
            {data.permissions.map((r, k) => (
              <Tag
                style={{ marginBottom: 5 }}
                key={k}
                color={r.enabled ? "#87d068" : "#f50"}
              >
                {permissionTranslation(r.action, intl)}
              </Tag>
            ))}
          </span>
        )
      }
      // {
      //   key: '3',
      //   title: intl.formatMessage({ id: "users" }),
      //   render: row => {
      //     return <div id='user'>
      //       <Dropdown
      //         getPopupContainer={() => document.getElementById('user')}
      //         overlay={(<Menu>
      //           {row.users.map((r, k) => <Menu.Item key={k} placement="bottomCenter">{r && r.email}</Menu.Item>)}
      //         </Menu>)}>
      //         <Button type="primary" size="small"> {intl.formatMessage({ id: "view" })}</Button>
      //       </Dropdown>
      //     </div>
      //   }
      // }
    ];

    const defaultColumnsAdmin = [
      ...defaultColumns,
      {
        key: "4",
        title: intl.formatMessage({ id: "detail_permissions" }),
        render: row => (
          <Button
            type="primary"
            style={{ backgroundColor: newColor, borderColor: newColor }}
            onClick={() => this.handleShowDetail(row._id)}
            size="small"
          >
            {intl.formatMessage({ id: "view_edit" })}
          </Button>
        )
      }
    ];

    const defaultColumnsOperator = [
      ...defaultColumns,
      {
        key: "4",
        title: intl.formatMessage({ id: "request_permissions" }),
        render: row => {
          return (
            <Button
              type="primary"
              style={{ backgroundColor: newColor, borderColor: newColor }}
              onClick={() =>
                this.handleShowRequestDrawer(
                  row,
                  otherGroup.find(r => r._id === row._id).userCreator
                )
              }
              size="small"
            >
              {intl.formatMessage({ id: "request" })}
            </Button>
          );
        }
      }
    ];

    this.setState({
      mergedData,
      columns:
        isSelectable && !isRemovable && !disableControls
          ? [
              ...(disableControls
                ? defaultColumnsOperator
                : defaultColumnsAdmin)
              // {
              //   key: '6',
              //   title: intl.formatMessage({ id: "associate_permissions" }),
              //   render: row => {
              //     const exists = dataSelected && dataSelected.find(r => r._id === row._id)

              //     return (<Switch
              //       checkedChildren={intl.formatMessage({ id: "yes" })}
              //       onChange={checked => this.handleOnChangeSelected(checked, row)}
              //       unCheckedChildren="no"
              //       defaultChecked={exists ? true : false}
              //       disabled={disableControls} />)
              //   }
              // }
            ]
          : isSelectable && isRemovable && !disableControls
          ? [
              ...(disableControls
                ? defaultColumnsOperator
                : defaultColumnsAdmin),
              // {
              //   key: '6',
              //   title: intl.formatMessage({ id: "associate_permissions" }),
              //   render: row => {
              //     const exists = row.objects.find(r => r === item._id)
              //     return (<Switch
              //       checkedChildren={intl.formatMessage({ id: "yes" })}
              //       onChange={checked => this.handleOnChangeSelected(checked, row)}
              //       unCheckedChildren="no"
              //       defaultChecked={exists ? true : false}
              //       disabled={disableControls} />)
              //   }
              // },
              {
                key: "7",
                title: intl.formatMessage({ id: "delete_asset" }),
                render: row => {
                  return (
                    <Popconfirm
                      title={intl.formatMessage({
                        id: "delete_group_question"
                      })}
                      okText={intl.formatMessage({ id: "yes" })}
                      cancelText="No"
                      onConfirm={() =>
                        this.handleDelete(row._id, disableControls)
                      }
                      disabled={disableControls}
                    >
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: newColor,
                          borderColor: newColor
                        }}
                        size="small"
                        disabled={disableControls}
                      >
                        {intl.formatMessage({ id: "delete_asset" })}
                      </Button>
                    </Popconfirm>
                  );
                }
              }
            ]
          : !isSelectable && isRemovable
          ? [
              ...(disableControls
                ? defaultColumnsOperator
                : defaultColumnsAdmin),
              {
                key: "6",
                title: intl.formatMessage({ id: "delete_asset" }),
                render: row => {
                  return (
                    <Popconfirm
                      title={intl.formatMessage({ id: "delete_asset" })}
                      okText={intl.formatMessage({ id: "yes" })}
                      cancelText="No"
                      onConfirm={() =>
                        this.handleDelete(row._id, disableControls)
                      }
                      disabled={disableControls}
                    >
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: newColor,
                          borderColor: newColor
                        }}
                        size="small"
                        disabled={disableControls}
                      >
                        {intl.formatMessage({ id: "delete_asset" })}
                      </Button>
                    </Popconfirm>
                  );
                }
              }
            ]
          : [
              ...(disableControls
                ? defaultColumnsOperator
                : defaultColumnsAdmin)
            ]
    });
  }

  componentDidUpdate(prevProps) {
    const { deleteStatus, workclient, data, defaultPermissions } = this.props;

    if (
      prevProps.deleteStatus === "" &&
      prevProps.deleteStatus !== deleteStatus
    ) {
      if (deleteStatus === "success") {
        this.props.getGroupByClient(workclient);
      }
    }
    if (prevProps.data && data && (prevProps.data.length !== data.length)) {
      const mergedData = data.map(group => {
        return {
          ...group,
          permissions: this.mergePermissions(
            group.permissions,
            defaultPermissions
          )
        };
      });
      this.setState({ mergedData });
    }
  }

  handleDelete = (id, isDisable) => {
    const { intl } = this.props;

    if (isDisable)
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "user_not_privileges" })
      );
    else this.props.deleteGroupById(id, intl);
  };

  handleShowDetail = id => {
    this.props.getRootFoldersByClient();
    this.props.getGroupById(id);
    this.setState({ showDetail: true });
  };

  handleHideDetail = () => {
    this.setState(
      {
        showDetail: false
      },
      () => {
        this.props.givingPermissions("HIDE");
      }
    );
  };

  handleOnChangeSelected = (checked, row) => {
    const { item, intl } = this.props;

    if (checked) {
      this.props.addObjectoToGroup(item._id, row._id, intl);
    } else {
      this.props.removeObjectFromGroup(item._id, row._id, intl);
    }
  };

  handleShowRequestDrawer = (row, userCreator) => {
    this.setState({
      showPermissionRequest: true,
      itemButton: { ...row, userCreator }
    });
  };

  handleHidePermissionRequest = () => {
    this.setState({
      showPermissionRequest: false
    });
  };
  mergePermissions = (groupPermissions, defaultPermissions) => {
    return defaultPermissions.map(defaultPermission => {
      const permissionDefined = groupPermissions.find(
        groupPermission => groupPermission.action === defaultPermission.action
      );

      if (permissionDefined) return permissionDefined;

      return { ...defaultPermission, enabled: false };
    });
  };
  render() {
    const {
      intl,
      allTheGroups,
      item,
      byClientIsFetching
    } = this.props;
    const {
      columns,
      showDetail,
      itemButton,
      showPermissionRequest,
      mergedData
    } = this.state;

    return (
      <React.Fragment>
        {allTheGroups && (
          <Alert
            message={`${intl.formatMessage({ id: "working_on" })}: ${
              item.name
            }`}
            type="info"
            style={{ marginBottom: 10 }}
          />
        )}

        {byClientIsFetching && (
          <div style={spinnerStyle}>
            <Spin spinning={byClientIsFetching} />
          </div>
        )}
        {!byClientIsFetching && (
          <Table
            rowKey="_id"
            size="small"
            columns={columns}
            dataSource={mergedData}
            pagination={false}
          />
        )}
        <Modal
          title={intl.formatMessage({ id: "group_detail" })}
          visible={showDetail}
          onCancel={this.handleHideDetail}
          width={"95%"}
          footer={null}
          centered
          closeIcon={<img src={CloseIcon} alt={"icon close"} />}
          // closable={true}
          // destroyOnClose={true}
        >
          {showDetail && <Detail handleHideDetail={this.handleHideDetail} />}
        </Modal>
        <Modal
          title={intl.formatMessage({ id: "permission_request" })}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          onCancel={this.handleHidePermissionRequest}
          onClose={this.handleHidePermissionRequest}
          visible={showPermissionRequest}
        >
          {showPermissionRequest && (
            <PermissionRequest
              item={itemButton}
              handleHidePermissionRequest={this.handleHidePermissionRequest}
            />
          )}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    root: state.client.root,
    deleteIsFetching: state.group.deleteIsFetching,
    deleteStatus: state.group.deleteStatus,
    item: state.permission.item,
    authUser: state.authUser.user,
    group: state.group.byClientData,
    width: state.app.width,
    otherGroup: state.group.byClientUserData,
    byClientIsFetching: state.group.byClientIsFetching,
    detail: state.group.detail,
    defaultPermissions: state.group.defaultPermissions,
    isFetchingObjectGroups: state.permission.isFetchingObjectGroups,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

const mapDispatchToProps = {
  getGroupById,
  deleteGroupById,
  getGroupByClient,
  addObjectoToGroup,
  removeObjectFromGroup,
  approvedRejectedUserRequest,
  givingPermissions,
  getRootFoldersByClient
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(List))
);
